import { useContext } from 'react';
import { useIntl } from 'react-intl';
import {
  TableCells,
  TableColumn,
  TableFilterCells,
  useStaticListSource,
} from '@eas/common-web';
import { ParticipantCell } from '@modules/es-file/es-file-columns';
import { StaticDataContext } from '@components/evidence/static-data-provider/static-data-provider';
import {
  autocompleteColumnMapper,
  subjectContactColumnMapper,
} from '@components/form/misc/label-mappers';
import { Loan } from '@models';

export function useColumns(): TableColumn<Loan>[] {
  const intl = useIntl();
  const { loanStates } = useContext(StaticDataContext);
  const useLoanStates = () => useStaticListSource(loanStates);

  return [
    {
      datakey: 'loanedOn',
      sortkey: 'loanedOn',
      filterkey: 'loanedOn',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Zapůjčeno dne',
        defaultMessage: 'Zapůjčeno dne',
      }),
      width: 140,
      CellComponent: TableCells.DateCell,
      FilterComponent: TableFilterCells.FilterDateCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'loanedFile.number.value',
      sortkey: 'loanedFile.number.valueSort',
      filterkey: 'loanedFile.number.value',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Spisová značka',
        defaultMessage: 'Spisová značka',
      }),
      width: 170,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'loanedFile.judge',
      sortkey: 'loanedFile.judge',
      filterkey: 'loanedFile.judge',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Soudce zpravodaj',
        defaultMessage: 'Soudce zpravodaj',
      }),
      width: 220,
      CellComponent: TableCells.TextCell,
      valueMapper: autocompleteColumnMapper,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'loanedFile.proposers',
      sortkey: 'loanedFile.proposers',
      filterkey: 'loanedFile.proposers',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Navrhovatel',
        defaultMessage: 'Navrhovatel',
      }),
      width: 220,
      CellComponent: ParticipantCell('loanedFile.proposers' as any),
      valueMapper: subjectContactColumnMapper,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'borrower.label',
      sortkey: 'borrower.label',
      filterkey: 'borrower.label',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Zapůjčeno komu',
        defaultMessage: 'Zapůjčeno komu',
      }),
      width: 200,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'loanedBy.label',
      sortkey: 'loanedBy.label',
      filterkey: 'loanedBy.label',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Zapůjčil',
        defaultMessage: 'Zapůjčil',
      }),
      width: 200,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'relatedFile.number.value',
      sortkey: 'relatedFile.number.valueSort',
      filterkey: 'relatedFile.number.value',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Ke spisové značce',
        defaultMessage: 'Ke spisové značce',
      }),
      width: 170,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'state',
      sortkey: 'state.name',
      filterkey: 'state.id',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Stav',
        defaultMessage: 'Stav',
      }),
      width: 140,
      CellComponent: TableCells.TextCell,
      FilterComponent:
        TableFilterCells.useFilterSelectCellFactory(useLoanStates),
      valueMapper: TableCells.useSelectCellFactory(useLoanStates),
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'returnedOn',
      sortkey: 'returnedOn',
      filterkey: 'returnedOn',
      name: intl.formatMessage({
        id: 'ES__LOANS__COLUMN__Vráceno dne',
        defaultMessage: 'Vráceno dne',
      }),
      width: 140,
      CellComponent: TableCells.DateCell,
      FilterComponent: TableFilterCells.FilterDateCell,
      sortable: true,
      filterable: true,
    },
  ];
}
